import api from '@/apis'

export default {
  state: {
    visibility: false,
    result: null,
    find_text: ''
  },
  mutations: {
    SET_AUDIO_FILE_TO_TEXT_RESULT_CARD_VISIBILITY(state, payload) {
      state.visibility = payload
    },
    SET_AUDIO_FILE_TO_TEXT_RESULT_CARD_RESULT(state, payload) {
      state.result = payload
    },
    SET_AUDIO_FILE_TO_TEXT_RESULT_CARD_ANNOTATION_SUBMIT_BTN_DISABLE(state, payload) {
      state.annotation_submit_btn_disable = payload
    },
    SET_AUDIO_FILE_TO_TEXT_RESULT_CARD_FIND_TEXT(state, payload) {
      state.find_text = payload
    }
  },
  actions: {
    async downloadTranscription({ rootState, state, commit }, format = null) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Downloading...', loading: true })

        const data = {
          params: { task_id: state.result.task_id, project_id: rootState.auth.project_id },
          query: {},
          headers: {
            headers: {
              access_token: process.env.VUE_APP_AUDIO_FILE_TO_TEXT_AUTH_TOKEN
            }
          }
        }

        if (format) {
          if (format) data.query.file_format = format.format
          if (format.use_written_language) data.query.use_written_language = format.use_written_language
          const response = await api.downloadAudioFileTranscription(data)
          const downloader = require('js-file-download')
          const header_content = response.headers['content-disposition']
          const filename = header_content.substring(header_content.indexOf('"') + 1, header_content.lastIndexOf('"'))

          downloader('\ufeff' + response.data, filename)
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
        } else {
          const response = await api.downloadAudioFileTranscription(data)
          if (response.data.success) {
            let json = 'text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(response.data.data.result.data))

            let a = document.createElement('a')
            a.href = 'data:' + json
            a.download = 'Transcription.json'
            a.click()
            commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
          } else throw Error(response.data.message)
        }
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async updateDialogue({ rootState, state, commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Updating...', loading: true })

        const response = await api.updateAudioFileResult({ project_id: rootState.auth.project_id, task_id: state.result.task_id, ...payload })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
          commit('RESET_DELETE_DIALOG')
          await dispatch('refreshAudioFileToTextResultCard')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async refreshAudioFileToTextResultCard({ rootState, state, commit }) {
      try {
        const data = {
          params: { task_id: state.result.task_id, project_id: rootState.auth.project_id },
          headers: {
            headers: {
              access_token: process.env.VUE_APP_AUDIO_FILE_TO_TEXT_AUTH_TOKEN
            }
          }
        }

        const response = await api.getAudioFileResult(data)
        if (response.data.success) {
          commit('SET_AUDIO_FILE_TO_TEXT_RESULT_CARD_RESULT', response.data.data)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    }
  }
}
